module.exports = __webpack_public_path__ + "static/media/service6.40a35463.svg";